import {
  getAvatarTexture,
  getTextureStyle,
} from "../../shared/utils/spritesheet";
import { useSpritesheetStore } from "../../store/spritesheetStore";
import css from "./ControlPanel.module.scss";

// Progressive freebet v2: порог сейчас 3 hit (см. FREEBET_PROGRESS_REQUIRED).
const BONUS_SLOTS_COUNT = 3;
const BONUS_ICON_WIDTH = 42;
const BONUS_ICON_HEIGHT = 30;

interface BonusIndicatorProps {
  currentProgress: number;
}

function getBonusIconStyle() {
  const tex = getAvatarTexture("BonusIcon.png");
  if (!tex) return null;

  const baseStyle = getTextureStyle(tex, {
    width: BONUS_ICON_WIDTH,
    height: BONUS_ICON_HEIGHT,
  });

  if (!baseStyle) return null;

  return {
    ...baseStyle,
    position: "absolute" as const,
    top: -10,
    right: 0,
  };
}

export function BonusIndicator({ currentProgress }: BonusIndicatorProps) {
  // Subscribe to spritesheet store to trigger re-render when avatars are ready
  const avatarsReady = useSpritesheetStore((s) => s.avatarsReady);
  const bonusIconStyle = avatarsReady ? getBonusIconStyle() : null;

  return (
    <div className={css.bonusBetsContainer}>
      {bonusIconStyle && <div style={bonusIconStyle} />}
      {Array.from({ length: BONUS_SLOTS_COUNT }, (_, index) => (
        <div
          key={index}
          className={`${css.bonusBetItem} ${index < currentProgress ? css.active : ""}`}
        />
      ))}
    </div>
  );
}
